module.exports = __webpack_public_path__ + "static/media/animal_category.0f1f1528.jpg";